class Ingredients extends HTMLElement {
    constructor() {
        super();
        this.isInitialized = false;
        this.activeIndex = '0';
        this.hasMobileSelection = false;
        this.desktopMediaQuery = window.matchMedia('(min-width: 1024px)');
    }

    connectedCallback() {
        this.#init();
    }

    #init() {
        if (this.isInitialized) return;

        const controls = this.querySelectorAll('.ingredients-controls__item');
        const items = this.querySelectorAll('.ingredients-item');
        const image = this.querySelector('.ingredients-image');

        if (controls.length === 0 || items.length === 0) return;

        this.isInitialized = true;

        this.#applyLayoutMode(controls, items, image);

        for (const control of controls) {
            control.addEventListener('click', () => {
                const index = control.dataset.index;
                this.activeIndex = index;

                if (!this.desktopMediaQuery.matches) {
                    this.hasMobileSelection = true;
                }

                this.#setVisibleItem(items, index);
                this.#setActiveControl(controls, index);
                this.#toggleImageVisibility(image, this.desktopMediaQuery.matches);
            });
        }

        const handleBreakpointChange = () => {
            this.#applyLayoutMode(controls, items, image);
        };

        this.desktopMediaQuery.addEventListener('change', handleBreakpointChange);
    }

    #applyLayoutMode(controls, items, image) {
        if (this.desktopMediaQuery.matches) {
            this.#setVisibleItem(items, this.activeIndex);
            this.#setActiveControl(controls, this.activeIndex);
            this.#toggleImageVisibility(image, true);
            return;
        }

        if (this.hasMobileSelection) {
            this.#setVisibleItem(items, this.activeIndex);
            this.#setActiveControl(controls, this.activeIndex);
            this.#toggleImageVisibility(image, false);
            return;
        }

        this.#hideAllItems(items);
        this.#setActiveControl(controls, null);
        this.#toggleImageVisibility(image, true);
    }

    #setVisibleItem(items, activeIndex) {
        items.forEach((item) => {
            const shouldShow = item.dataset.index === activeIndex;
            const icon = item.querySelector('.ingredients-item-icon');

            if (!shouldShow) {
                item.hidden = true;
                if (icon) icon.classList.remove('is-visible');
                return;
            }

            item.hidden = false;
            if (!icon) return;

            icon.classList.remove('is-visible');
            requestAnimationFrame(() => {
                icon.classList.add('is-visible');
            });
        });
    }

    #hideAllItems(items) {
        for (const item of items) {
            item.hidden = true;
            const icon = item.querySelector('.ingredients-item-icon');
            if (icon) icon.classList.remove('is-visible');
        }
    }

    #toggleImageVisibility(image, shouldShow) {
        if (!image) return;

        image.classList.toggle('ingredients-image--hidden', !shouldShow);
    }

    #setActiveControl(controls, activeIndex) {
        for (const control of controls) {
            const isActive = activeIndex !== null && control.dataset.index === activeIndex;
            control.classList.toggle('is-active', isActive);
            control.toggleAttribute('active', isActive);
            control.setAttribute('aria-selected', String(isActive));
        }
    }
}

customElements.define('ingredients-selector', Ingredients);
